import { useQueryClient } from 'react-query';

import {
  GET_COMPANY_MANIFEST_QUERY_KEY,
  EnrollmentContextResponseDto,
  ContentSettingsResponseDto,
  GET_CONTENT_SETTINGS_QUERY_KEY,
} from 'theSource/queries';
import { CompanyManifestResponseDto } from 'theSource/queries/useCompanyManifestQuery/types';
import { ForegroundImageStyled, HeroGradientStyled } from './HeroStyled';
import './Hero.css';

interface HeroProps {
  contexts?: EnrollmentContextResponseDto;
  children?: React.ReactNode;
}

export const Hero = ({ contexts, children }: HeroProps) => {
  const queryClient = useQueryClient();
  const manifestData: CompanyManifestResponseDto = queryClient.getQueryData(
    GET_COMPANY_MANIFEST_QUERY_KEY
  )!;
  const contentSettings: ContentSettingsResponseDto | undefined =
    queryClient.getQueryData(GET_CONTENT_SETTINGS_QUERY_KEY);

  const secondarycolor = `#${contentSettings?.navigation_background_color}`;
  // when a life event is open, it has a white informational box, and should be counted as 'context'. "not_open" status is considered "no-context".
  let activeContexts = [];
  if (contexts?.data?.length) {
    activeContexts = contexts.data.filter(
      (context) => context.status !== 'not_open'
    );
  }
  const curveMaskClass = activeContexts.length > 0 ? 'context' : 'no-context';

  return (
    <div id="hero" data-testid="hero">
      <HeroGradientStyled secondarycolor={secondarycolor}>
        <ForegroundImageStyled
          className={curveMaskClass}
          // className determine which mask curve to use. See Figma for with "context", and "no-context" (other className) examples.
          data-testid="foreground-image"
          src={manifestData?.background_image}
          alt="" // w3c decorative img handling
        />
      </HeroGradientStyled>

      <div
        className={`hero-content ${curveMaskClass}`}
        data-testid="hero-content"
      >
        {children}
      </div>
    </div>
  );
};
